import { NeighborhoodShowcaseProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  NeighborhoodShowcaseProps["options"],
  OptionalPropertyOf<NeighborhoodShowcaseProps["options"]>
> = {};

export default defaultState;
